import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import vacationValidationSchema from './vacationValidationSchema';
import { useAuth } from '../../../auth';
import VacationRequestForm from './VacationRequestForm';
import { useTenant } from '../../../hooks/useTenant';
import { createVacationRequest } from '../../../services/vacationService';

const withTime = (value, hours = 10, minutes = 0, seconds = 0, ms = 0) => {
  const d = value instanceof Date ? new Date(value) : new Date(value);
  d.setHours(hours, minutes, seconds, ms);
  return d;
};

const submitVacationRequest = async (values, getToken, enqueueSnackbar) => {
  const startAt10 = withTime(values.startDate);
  const endAt10 = withTime(values.endDate);

  try {
    const result = await createVacationRequest(getToken, {
      startDate: startAt10.toISOString(),
      endDate: endAt10.toISOString(),
      description: values.description,
    });

    if (result?.status !== 'OK') {
      throw new Error(result?.message || 'Request failed');
    }

    enqueueSnackbar('Vacation request successfully submitted for approval', {
      variant: 'success',
    });
  } catch (err) {
    enqueueSnackbar(err.message || 'Error when submitting vacation request', {
      variant: 'error',
    });
    console.error('Vacation request submission failed: ', err);
  }
};

const VacationRequestFormContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { getToken } = useAuth();
  const tenant = useTenant();

  return (
    <Formik
      enableReinitialize
      initialErrors={[]}
      validationSchema={vacationValidationSchema}
      initialValues={{}}
      onSubmit={async (values, { resetForm }) => {
        if (!tenant) return;

        await submitVacationRequest(values, getToken, enqueueSnackbar);

        resetForm();
      }}
    >
      {form => <VacationRequestForm formProps={form} tenantLoaded={!!tenant} />}
    </Formik>
  );
};

export default VacationRequestFormContainer;
